import React, { useContext } from "react";
import ElipsisCell from "../../components/TableBox/Cells/EllipsisCell";
import ElipsisText from "../../components/ElipsisText";
import { TableContext } from "../../contexts/TableContext";
import { VALIDATION_FIELD_MAPPING } from "../../utils/appConstant";
import { formatDollarAmount } from "../../utils/methods";
import { RowClassName } from "../../enums";

interface PayoutAmtRowProps {
  item: any;
  className?: RowClassName;
}

const PayoutAmtRow: React.FC<PayoutAmtRowProps> = ({
  item,
  className,
}) => {
  const { headCells } = useContext(TableContext);

  const isExcluded = item?.consider === false;
  const textColorClass = isExcluded ? "text-danger text-decoration-line-through" : "";

  const dateNode = (
    <ElipsisText width="100%" text={item?.date || '-'} className={`text-nowrap ${textColorClass}`} />
  );

  const paymentDetailsNode = (
    <ElipsisText width="100%" text={item?.payout_details || '-'} className={textColorClass} />
  );

  const amountNode = (
    <ElipsisText width="100%" text={item?.amt ? `${formatDollarAmount(item.amt)}` : '-'} className={`text-nowrap ${textColorClass}`} />
  );

  return (
    <>
      <tr className={className}>
        {
          headCells?.map((cell, index) => {
            switch (cell.id) {
              case VALIDATION_FIELD_MAPPING.date:
                return <ElipsisCell key={index} node={dateNode} width={cell.width} />;
              case VALIDATION_FIELD_MAPPING.paymentDetails:
                return <ElipsisCell key={index} node={paymentDetailsNode} width={cell.width} />;
              case VALIDATION_FIELD_MAPPING.amount:
                return <ElipsisCell key={index} node={amountNode} width={cell.width} />;
              default:
                return <td key={index} style={{ width: cell.width }}></td>;
            }
          })
        }
      </tr>
    </>
  );
};

export default PayoutAmtRow;
